module.exports = __webpack_public_path__ + "img/icon-add-light.2cdd4486.svg";